// extracted by mini-css-extract-plugin
export var alertIcon = "_rm-0";